<template>
    <div>
        <LiefengContent>
            <template v-slot:title>角色管理</template>
            <template v-slot:toolsbarRight>
                <Form :label-colon="true" :inline="true" class="search">
                    <FormItem>
                        <Input v-model.trim="searchData.name" style="width: 180px" placeholder="角色名称" clearable></Input>
                    </FormItem>
                    <Button type="primary" icon="ios-search" style="margin-right: 10px" @click="handleSearch">查询</Button>
                    <Button type="success" icon="ios-refresh" style="margin-right: 10px" @click="resetBtn">重置</Button>
                    <Button type="primary" icon="ios-add" @click="handleAdd">新增</Button>
                </Form>
            </template>
            <template v-slot:contentArea>
                <LiefengTable
                    :talbeColumns="talbeColumns"
                    :tableData="tableData"
                    :loading="loading"
                    :fixTable="true"
                    :curPage="page"
                    :total="total"
                    :pagesizeOpts="[20, 30, 50, 100]"
                    :page-size="pageSize"
                    @hadlePageSize="hadlePageSize"
                ></LiefengTable>
            </template>
        </LiefengContent>

        <!-- 新增/修改 -->
        <LiefengModal
            :title="editType === 'add' ? '新增角色' : '修改角色'"
            :value="editStatus"
            @input="changeEditStatus"
            width="480px"
            height="320px"
        >
            <template v-slot:contentarea>
                <Form :label-width="120">
                    <FormItem label="角色名称">
                        <span slot="label" class="validate">角色名称:</span>
                        <Input v-model.trim="formData.name" style="width: 280px" :maxlength="20" placeholder="请填写角色名称"></Input>
                    </FormItem>
                    <FormItem v-if="isSuperAdmin" label="机构编码">
                        <span slot="label" class="validate">机构编码:</span>
                        <Input v-model.trim="formData.orgCode" style="width: 280px" placeholder="请填写所属组织机构编码"></Input>
                    </FormItem>
                    <FormItem label="备注">
                        <Input v-model.trim="formData.description" type="textarea" :rows="3" style="width: 280px" placeholder="请填写备注"></Input>
                    </FormItem>
                </Form>
            </template>
            <template v-slot:toolsbar>
                <Button type="primary" style="margin-right: 10px" @click="saveEdit">保存</Button>
                <Button type="info" @click="changeEditStatus(false)">取消</Button>
            </template>
        </LiefengModal>

        <!-- 角色授权 -->
        <LiefengModal title="角色授权" :value="menuGrantStatus" @input="val => (menuGrantStatus = val)" width="560px" height="520px">
            <template v-slot:contentarea>
                <div class="tree-wrap">
                    <Tree ref="menuTree" :data="menuTreeData" show-checkbox expand-node></Tree>
                </div>
            </template>
            <template v-slot:toolsbar>
                <Button type="primary" style="margin-right: 10px" @click="saveMenuGrant">保存</Button>
                <Button type="info" @click="menuGrantStatus = false">取消</Button>
            </template>
        </LiefengModal>

        <!-- 角色员工 -->
        <LiefengModal title="角色员工" :value="staffGrantStatus" @input="val => (staffGrantStatus = val)" width="680px" height="520px">
            <template v-slot:contentarea>
                <LiefengTable
                    :talbeColumns="staffColumns"
                    :tableData="staffList"
                    :loading="staffLoading"
                    :fixTable="false"
                    :hidePage="true"
                    @tableSelect="onStaffSelect"
                ></LiefengTable>
            </template>
            <template v-slot:toolsbar>
                <Button type="primary" style="margin-right: 10px" @click="saveStaffGrant">保存</Button>
                <Button type="info" @click="staffGrantStatus = false">取消</Button>
            </template>
        </LiefengModal>

        <!-- 数据授权 -->
        <LiefengModal title="数据授权" :value="dataGrantStatus" @input="val => (dataGrantStatus = val)" width="480px" height="420px">
            <template v-slot:contentarea>
                <Checkbox v-model="dataAuthAll" @on-change="toggleDataAuthAll">全选</Checkbox>
                <div class="data-auth-list">
                    <Checkbox v-model="item.checked" v-for="item in dataAuthList" :key="item.authCode">{{ item.name }}</Checkbox>
                </div>
            </template>
            <template v-slot:toolsbar>
                <Button type="primary" style="margin-right: 10px" @click="saveDataGrant">保存</Button>
                <Button type="info" @click="dataGrantStatus = false">取消</Button>
            </template>
        </LiefengModal>
    </div>
</template>

<script>
import LiefengContent from "@/components/LiefengContent3"
import LiefengTable from "@/components/LiefengTable"
import LiefengModal from "@/components/LiefengModal"

export default {
    components: { LiefengContent, LiefengTable, LiefengModal },
    data() {
        return {
            searchData: { name: "" },
            tableData: [],
            loading: false,
            page: 1,
            pageSize: 20,
            total: 0,
            editType: "add",
            editStatus: false,
            formData: {},
            orgCode: "",
            adminType: "",
            oemCode: "",
            currentRoleId: null,
            menuGrantStatus: false,
            menuTreeData: [],
            staffGrantStatus: false,
            staffLoading: false,
            staffList: [],
            selectedStaffIds: [],
            dataGrantStatus: false,
            dataAuthList: [],
            dataAuthAll: false,
            isSuperAdmin: false,
            staffColumns: [
                { type: "selection", width: 60, align: "center" },
                { title: "员工名称", key: "userName", minWidth: 120, align: "center" },
                { title: "工号", key: "userAccount", minWidth: 120, align: "center" },
                {
                    title: "在职状态",
                    key: "workStatus",
                    minWidth: 100,
                    align: "center",
                    render: (h, params) => h("span", params.row.workStatus === "2" ? "离职" : "在职"),
                },
            ],
            talbeColumns: [
                { title: "所属机构", key: "orgName", minWidth: 160, align: "center" },
                { title: "角色名称", key: "name", minWidth: 140, align: "center" },
                { title: "备注", key: "description", minWidth: 180, align: "center" },
                {
                    title: "操作",
                    align: "center",
                    fixed: "right",
                    width: 280,
                    render: (h, params) => {
                        const style = { marginRight: "8px", color: "#2d8cf0", cursor: "pointer", userSelect: "none" }
                        const actions = [
                            { label: "修改", fn: () => this.handleEdit(params.row) },
                            { label: "角色授权", fn: () => this.openMenuGrant(params.row) },
                            { label: "角色员工", fn: () => this.openStaffGrant(params.row) },
                            { label: "数据授权", fn: () => this.openDataGrant(params.row) },
                            { label: "删除", fn: () => this.handleDelete(params.row) },
                        ]
                        return h(
                            "div",
                            { style: { textAlign: "center" } },
                            actions.map(a => h("span", { style, on: { click: a.fn } }, a.label))
                        )
                    },
                },
            ],
        }
    },
    created() {
        this.initContext()
        this.getList()
    },
    methods: {
        initContext() {
            this.orgCode = window.sessionStorage.getItem("orgCode") || parent.vue.loginInfo.userinfo.orgCode || ""
            this.adminType = parent.vue.loginInfo.userinfo.adminType || ""
            this.oemCode = parent.vue.oemInfo.oemCode
            this.isSuperAdmin = this.adminType === "100"
        },
        getList() {
            this.loading = true
            this.$get("/old/api/pc/role/listRoles4page", {
                adminType: this.adminType,
                orgCode: this.orgCode,
                name: this.searchData.name || undefined,
                page: this.page,
                pageSize: this.pageSize,
            })
                .then(res => {
                    this.loading = false
                    if (res.code == 200 || res.code == "200") {
                        this.tableData = res.dataList || []
                        this.total = res.maxCount || 0
                    } else {
                        this.$Message.error({ content: res.desc || "数据获取失败", background: true })
                    }
                })
                .catch(() => {
                    this.loading = false
                })
        },
        handleSearch() {
            this.page = 1
            this.getList()
        },
        resetBtn() {
            this.searchData.name = ""
            this.page = 1
            this.pageSize = 20
            this.getList()
        },
        hadlePageSize(page, pageSize) {
            this.page = page
            this.pageSize = pageSize
            this.getList()
        },
        changeEditStatus(val) {
            this.editStatus = val
            if (!val) this.formData = {}
        },
        handleAdd() {
            this.editType = "add"
            this.formData = { name: "", description: "", orgCode: this.isSuperAdmin ? "" : this.orgCode }
            this.editStatus = true
        },
        handleEdit(row) {
            this.editType = "update"
            this.formData = {
                id: row.id,
                name: row.name,
                description: row.description,
                orgCode: row.orgCode,
            }
            this.editStatus = true
        },
        validateForm() {
            if (!this.formData.name || this.formData.name.length > 20) {
                this.$Message.warning({ content: "名称不能为空且不超过20字", background: true })
                return false
            }
            if (this.editType === "add" && this.isSuperAdmin && !this.formData.orgCode) {
                this.$Message.warning({ content: "请填写所属组织机构编码", background: true })
                return false
            }
            return true
        },
        saveEdit() {
            if (!this.validateForm()) return
            const data = { ...this.formData }
            if (this.editType === "add" && !this.isSuperAdmin) {
                data.orgCode = this.orgCode
            }
            const url = this.editType === "add" ? "/old/api/pc/role/createRole" : "/old/api/pc/role/updateRole"
            this.$post(url, data).then(res => {
                if (res.code == 200 || res.code == "200") {
                    this.$Message.success({ content: "保存成功", background: true })
                    this.changeEditStatus(false)
                    this.getList()
                } else {
                    this.$Message.error({ content: res.desc || "保存失败", background: true })
                }
            })
        },
        handleDelete(row) {
            this.$Modal.confirm({
                title: "删除确定",
                content: "是否删除该角色？",
                onOk: () => {
                    this.$post("/old/api/pc/role/delRole", { id: row.id }).then(res => {
                        if (res.code == 200 || res.code == "200") {
                            this.$Message.success({ content: "删除成功", background: true })
                            this.getList()
                        } else {
                            this.$Message.error({ content: res.desc || "删除失败", background: true })
                        }
                    })
                },
            })
        },
        openMenuGrant(row) {
            this.currentRoleId = row.id
            this.$get("/old/api/pc/role/listMenusAndCheck", {
                adminType: this.adminType,
                orgCode: this.orgCode,
                roleId: row.id,
                oemCode: this.oemCode,
            }).then(res => {
                if (res.code == 200 || res.code == "200") {
                    this.menuTreeData = this.buildMenuTree(res.dataList || [])
                    this.menuGrantStatus = true
                } else {
                    this.$Message.error({ content: res.desc || "获取菜单失败", background: true })
                }
            })
        },
        buildMenuTree(list) {
            const map = {}
            const roots = []
            list.forEach(item => {
                map[item.id] = {
                    title: item.name,
                    id: item.id,
                    checked: item.isSelect === 1,
                    expand: true,
                    children: [],
                }
            })
            list.forEach(item => {
                const node = map[item.id]
                if (item.parentId && item.parentId !== "0" && map[item.parentId]) {
                    map[item.parentId].children.push(node)
                } else {
                    roots.push(node)
                }
            })
            const trimEmpty = nodes => {
                nodes.forEach(n => {
                    if (!n.children.length) delete n.children
                    else trimEmpty(n.children)
                })
            }
            trimEmpty(roots)
            return roots.length ? roots : Object.values(map)
        },
        saveMenuGrant() {
            const nodes = this.$refs.menuTree.getCheckedNodes()
            const menuIds = nodes.map(n => n.id).join(",")
            this.$post("/old/api/pc/role/grantRoleMenus", {
                roleId: this.currentRoleId,
                menuIds,
            }).then(res => {
                if (res.code == 200 || res.code == "200") {
                    this.$Message.success({ content: "授权成功", background: true })
                    this.menuGrantStatus = false
                } else {
                    this.$Message.error({ content: res.desc || "授权失败", background: true })
                }
            })
        },
        openStaffGrant(row) {
            this.currentRoleId = row.id
            this.staffGrantStatus = true
            this.staffLoading = true
            this.selectedStaffIds = []
            this.$get("/old/api/pc/role/listStaffs", { orgCode: this.orgCode, roleId: row.id }).then(res => {
                this.staffLoading = false
                if (res.code == 200 || res.code == "200") {
                    this.staffList = (res.dataList || []).map(item => ({
                        ...item,
                        _checked: !!item.selectStatus,
                    }))
                    this.selectedStaffIds = this.staffList.filter(s => s.selectStatus).map(s => s.userId)
                } else {
                    this.$Message.error({ content: res.desc || "获取员工失败", background: true })
                }
            })
        },
        onStaffSelect(selection) {
            this.selectedStaffIds = selection.map(s => s.userId)
        },
        saveStaffGrant() {
            this.$post("/old/api/pc/role/bindUsersWithRole", {
                roleId: this.currentRoleId,
                userIdss: this.selectedStaffIds.join(","),
            }).then(res => {
                if (res.code == 200 || res.code == "200") {
                    this.$Message.success({ content: "保存成功", background: true })
                    this.staffGrantStatus = false
                } else {
                    this.$Message.error({ content: res.desc || "保存失败", background: true })
                }
            })
        },
        openDataGrant(row) {
            this.currentRoleId = row.id
            this.$get("/old/api/pc/role/getDataAuthList", { roleId: row.id }).then(res => {
                if (res.code == 200 || res.code == "200") {
                    this.dataAuthList = (res.dataList || []).map(item => ({
                        ...item,
                        checked: item.isSelect === 1,
                    }))
                    this.dataAuthAll = this.dataAuthList.length > 0 && this.dataAuthList.every(i => i.checked)
                    this.dataGrantStatus = true
                } else {
                    this.$Message.error({ content: res.desc || "获取数据权限失败", background: true })
                }
            })
        },
        toggleDataAuthAll(val) {
            this.dataAuthList.forEach(item => {
                item.checked = val
            })
        },
        saveDataGrant() {
            const authCodes = this.dataAuthList
                .filter(i => i.checked)
                .map(i => i.authCode)
                .join(",")
            this.$post("/old/api/pc/role/grantRoleDataAuths", {
                roleId: this.currentRoleId,
                authCodes,
            }).then(res => {
                if (res.code == 200 || res.code == "200") {
                    this.$Message.success({ content: "授权成功", background: true })
                    this.dataGrantStatus = false
                } else {
                    this.$Message.error({ content: res.desc || "授权失败", background: true })
                }
            })
        },
    },
}
</script>

<style lang="less" scoped>
/deep/ #toolsbarRight {
    width: 100%;
    .search {
        width: 100%;
        text-align: right;
        .ivu-form-item {
            margin-bottom: 0;
        }
    }
}
.tree-wrap {
    max-height: 400px;
    overflow: auto;
}
.data-auth-list {
    margin-top: 12px;
    /deep/ .ivu-checkbox-wrapper {
        display: block;
        margin-bottom: 8px;
    }
}
/deep/ .validate {
    &::before {
        content: "*";
        display: inline-block;
        margin-right: 4px;
        line-height: 1;
        font-family: SimSun;
        font-size: 14px;
        color: #ed4014;
    }
}
</style>
